
import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
// SONARimport Radio from "@material-ui/core/Radio";
// import RadioGroup from "@material-ui/core/RadioGroup";
// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import FormControl from "@material-ui/core/FormControl";
import { withStyles } from "@material-ui/core/styles";
// import Checkbox from "@material-ui/core/Checkbox";
import ChevronLeftSharpIcon from "@material-ui/icons/ChevronLeftSharp";
import {
  searchExistingApplication,
  searchProspect,
  searchCampaign,
  setStateParams,
  keyPerformanceByAgent,
  keyPerformanceByCampaign,
} from "../Redux/Actions/webAppActions";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import {
  getAgentPerformanceExport,
  getCampaignPerformanceExport
} from "../Redux/Actions/ExportActions"
import {setUserManagementState} from "../Redux/Actions/UserManagementAction"

// import { makeStyles } from "@material-ui/core/styles";
import AutoComplete1 from "../Utils/GenericUI/Select";
import AutoComplete from "../Utils/Select";
import Button from "../Utils/GenericUI/Button";
import Input from "../Utils/GenericUI/Input";
import CloseIcon from "@material-ui/icons/Close";
import { INITIAL_STATE } from "./initialState";
import { handleDateChange } from "../Utils/DateFormatter";
import * as DateUtil from "../Utils/DatePicker";
import { DataValidation, VERDA_CONSTS } from "../Utils/StaticData/Constant";
import Autocomplete2 from "../Utils/GenericUI/Select";

const CustomCloseIcon = withStyles({
  root: {
    color: "white",
    fontsize: "10px",
    hover: {
      "&:hover": {
        fontSize: "11px",
      },
    },
  },
})(CloseIcon);

const initialSearchState={      searchPayload: { appId: "", category: "", status: "" },
prospectSearchPayload: {
  fname: "",
  lname: "",
  assigned: "",
  prospectStatus: "",
  leadId: "",
  campaignName: "",
  campaignStatus:""
},
searchUser:{userId:""},
displayStatusDropdown: false,
buttonName: "",
planCampaignName: "",
enrlCampaignId: "",
campaignOwner: "",
startDate: "",
endDate: "",
snackBarOpen: false,
alertMsg: "",
severity: "",
vertical: "top",
horizontal: "center",
}

class SideBarDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialSearchState };
  }
  async componentDidMount() {
    this.setState({ ...initialSearchState });
    if (this.props.isAgentRole === true) {
      await this.setState((prevState) => ({
        ...prevState,
        prospectSearchPayload: {
          ...prevState.prospectSearchPayload,
          assigned: this?.props?.agentId?.trim(),
        },
      }));
    }
  }
  componentDidUpdate(prevProps, state) {
    if (
      prevProps.campaignState !== this.props.campaignState ||
      prevProps.prospectState !== this.props.prospectState
    ) {
      this.props.handleSearchCrite("", "");
      this.setState({
        ...initialSearchState,
        prospectSearchPayload: {
          ...initialSearchState.prospectSearchPayload,
          assigned:
            this.props.isAgentRole === true ? this?.props?.agentId?.trim() : "",
        },
      });
    }
    this.props.setCurrentSearchData(this.state);
  }
  componentWillUnmount() {
    this.props.handleSearchCrite("", "");
  }
  // static getDerivedStateFromProps(props, state) {
  //   let updateState={...state}
  //    if(!props?.isSuperUser && props?.customerId==="HCF0450"){
  //     console.log("clsgetder")
  //     updateState={...updateState, prospectSearchPayload: {
  //       ...state.prospectSearchPayload,
  //       assigned:props?.agentFullName?.trim()
  //     }}
  //   }

  //  return updateState;
  // }
  changeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value.toUpperCase(),
    });
  };
  reset = async () => {
    this.setState(() => ({
      planCampaignName: "",
      enrlCampaignId: "",
      startDate: "",
      endDate: "",
      prospectSearchPayload: {
        fname: "",
        lname: "",
        assigned:
          !this?.props?.isSuperUser && this?.props?.customerId === "HCF0450"
            ? this?.props?.agentId?.trim()
            : "",
        prospectStatus: "",
        leadId: "",
        campaignName: "",
        campaignStatus: "",
      },

      searchPayload: { appId: "", category: "", status: "",prospectStatus:"" },
      campaignOwner:"",
      searchUser:{userId:""}
    }));
    if(this.props.searchUserState){
      await this.props.setUserManagementState("UserManagementDataFiltered",this.props.UserManagementData)
      return
    }
    if(this.props.isAgentRole===true){

      await this.setState((prevState) => ({
        ...prevState,
        prospectSearchPayload: {
          ...prevState.prospectSearchPayload,
          assigned: this?.props?.agentId?.trim(),
        },
      }));
    }
    if (this.props.searchappl === true) {
      let searchPayload = {
        //agentEmail: this.props.emailId,
        applCategory: "",
        applStatus: "",
        applId: "",
      };
      await this.props.searchExistingApplication(
        searchPayload,
        this.props?.customerId,
        this.props.agentEmailId
      );
    }
    await this.props.setStateParams("search", true);
     {this.props.prospectState &&
    await this.props.searchProspect({
      planCampaignId: "",
      firstName: "",
      lastName: "",
      statusType: "",
      assignedTo:
        !this?.props?.isSuperUser && this?.props?.customerId === "HCF0450"
          ? this?.props?.agentId?.trim()
          : "",
      leadIdNbr: "",
    });
  }
  {this.props.campaignState &&
    await this.props.searchCampaign(
      this.state.planCampaignName,
      this.state.enrlCampaignId,
      this.state.campaignOwner,
      this.state.searchPayload?.prospectStatus
    );
  }
    this.props.handleSearchflag(true);
    this.props.handleSearchCrite(
      this.state.enrlCampaignId,
      this.state.planCampaignName
    );
  };
  handleSearch = async (e) => {
    const { searchPayload } = this.state;
    this.props.handleSearchflag(true);
    this.props.handleSearchCrite(
      this.state.enrlCampaignId,
      this.state.planCampaignName
    );
    await this.props.setStateParams("search", true);
    const { prospectSearchPayload } = this.state;
    e.preventDefault();
    let prospectPayload = {
      firstName: prospectSearchPayload.fname,
      lastName: prospectSearchPayload.lname,
      statusType: prospectSearchPayload.prospectStatus,
      assignedTo:
        prospectSearchPayload.assigned === "Select"
          ? ""
          : prospectSearchPayload.assigned,
      leadIdNbr: prospectSearchPayload.leadId,
      planCampaignId: prospectSearchPayload.campaignName,
    };
    let payload = {
      //agentEmail: this.props.emailId,
      applCategory: searchPayload.category,
      applStatus: searchPayload.status,
      applId: searchPayload.appId,
    };

    if(!this.props.searchUserState)
    { 
      this.props.prospect && !this.props.campaign && !this.props.keyPerformanceByAgentEntry && !this.props.keyPerformanceByCampaignEntry

        ? await this.props.searchProspect(prospectPayload)
        : !this.props.prospect &&
          this.props.campaign &&
          !this.props.keyPerformanceByAgentEntry &&
          !this.props.keyPerformanceByCampaignEntry
        ? await this.props.searchCampaign(
            this.state.planCampaignName,
            this.state.enrlCampaignId,
            this.state.campaignOwner,
            prospectSearchPayload.campaignStatus
          )
        : !this.props.prospect &&
          !this.props.campaign &&
          !this.props.keyPerformanceByAgentEntry &&
          !this.props.keyPerformanceByCampaignEntry
        ? await this.props.searchExistingApplication(
            payload,
            this.props?.customerId,
            this.props.agentEmailId
          )
        : !this.props.prospect &&
          !this.props.campaign &&
          this.props.keyPerformanceByAgentEntry &&
          !this.props.keyPerformanceByCampaignEntry
        ? await this.props.keyPerformanceByAgent({
            startDate: this.state.startDate,
            endDate: this.state.endDate,
          })
        : await this.props.keyPerformanceByCampaign({
            startDate: this.state.startDate,
            endDate: this.state.endDate,
          });
      // history.push("/e-Enroll/select-pin");
      
    }
    if (
      !this.props.prospect &&
      !this.props.campaign &&
      this.props.keyPerformanceByAgentEntry &&
      !this.props.keyPerformanceByCampaignEntry
    ) {
      await this.props.getAgentPerformanceExport({
        startDate: this.state.startDate,
        endDate: this.state.endDate,
      });
    }

    if (!this.props.prospect && !this.props.campaign && !this.props.keyPerformanceByAgentEntry && this.props.keyPerformanceByCampaignEntry) {
      await this.props.getCampaignPerformanceExport({ startDate: this.state.startDate, endDate: this.state.endDate })
  
    }
    if(this.props.searchUserState){
      let filteredSearch=this.props?.UserManagementData.filter((obj)=>obj.userId.toUpperCase().includes(this.state.searchUser.userId?.trim()?.toUpperCase()))
      await this.props.setUserManagementState("UserManagementDataFiltered",filteredSearch)

    }
  };

  handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDates(fieldId, e.target.value);
    });
  };

  setDates = async (fieldId, value) => {
    await this.setState({ ...this.state, [fieldId]: value });
    // await this.setState({
    //   data: { ...this.state.data, [name]: value },
    // });
  };
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };
  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = handleDateChange(value);
    if (value === "") {
      this.setState({
        snackBarOpen: true,
        alertMsg: "Please enter date in the MM/DD/YYYY format",
        severity: "error",
      });
    }
    await this.setState({ ...this.state, [name]: value });
  };

  handleSearchFieldChange = (event, name) => {
    let value = "";
    value = event.target ? event.target.value.toUpperCase() : event.value;
    if(name==="userId"){
      this.setState({
        searchUser:{
          [name]:value
        }
      })
    }
    if (name === "category" && value === "SUBMITTED") {
      this.setState((prevState) => ({
        ...prevState,
        displayStatusDropdown: true,
        prospectSearchPayload: {
          ...prevState.prospectSearchPayload,
          [name]: value,
        },

        searchPayload: {
          ...prevState.searchPayload,
          [name]: value,
        },
        buttonName: "View",
      }));
    } else if (
      (name === "category" && (value === "IN PROGRESS" || value === "READY")) ||
      ((name === "prospectStatus" || name === "campaignStatus") &&
        (value === "Open" || value === "Hold" || value === "Close"))
    ) {
      this.setState((prevState) => ({
        ...prevState,
        displayStatusDropdown: false,
        prospectSearchPayload: {
          ...prevState.prospectSearchPayload,
          [name]: value,
        },
        searchPayload: {
          ...prevState.searchPayload,
          [name]: value,
          status: "",
        },
        buttonName: "Edit",
      }));
    } else {
      this.setState((prevState) => ({
        searchPayload: {
          ...prevState.searchPayload,
          [name]: value,
        },
        prospectSearchPayload: {
          ...prevState.prospectSearchPayload,
          [name]: value,
        },
      }));
    }
  };
  handleOtherDropdown = (name) => async (event) => {
    let value = "";
    // if (name === "assigned") {
    //value = event.target ? event.target.label : event.label || event.value;
    // } else {
    value = event.target ? event.target.value : event.value || event.label;
    // }
    this.setState((prevState) => ({
      searchPayload: {
        ...prevState.searchPayload,
        [name]: value,
      },
      prospectSearchPayload: {
        ...prevState.prospectSearchPayload,
        [name]: value,
      },
    }));
  };
  handleDropdown = (name) => async (event) => {
    let value = event.target ? event.target.label : event.label || event.value;
    if (value === "---Select---") {
      value = "";
    }
    this.setState({ ...this.state, [name]: value });
  };
  render() {
    const {
      categoryLabels,
      statusLabels,
      show,
      //setSideBar,
      prospectStatusLabels,
    } = this.props;


    const { searchPayload,searchUser, displayStatusDropdown, prospectSearchPayload, snackBarOpen, severity, alertMsg, vertical, horizontal } = this.state;


    //SONAR const { searchPayload, displayStatusDropdown, buttonName } = this.state;
    //SONAR const { appId, category, status } = this.state.searchPayload;
    let catergoryOptions = [{ label: "Select", value: "" }];
    let prospectStatusOptions = [{ label: "Select", value: "" }];
    let statusOptions = [{ label: "SELECT", value: "" }];
    if (categoryLabels) {
      categoryLabels.map((category2) => {
        let temp = {};
        temp = { label: category2, value: category2 };
        catergoryOptions.push(temp);
      });
    }
    if (prospectStatusLabels) {
      prospectStatusLabels.map((prospectStatus) => {
        let tmp = {};
        tmp = { label: prospectStatus, value: prospectStatus };
        prospectStatusOptions.push(tmp);
      });
    }
    if (statusLabels) {
      statusLabels.map((category1) => {
        statusOptions.push(category1);
      });
    }
    return (
      <div>
        <Snackbar
          open={snackBarOpen}
          autoHideDuration={6000}
          onClose={this.handleClose}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert onClose={this.handleClose} severity={severity}>
            {alertMsg}
          </Alert>
        </Snackbar>

        {(this.props.prospect || this.props.campaign || this.props.searchUserState )?

          <><div
            class={
              show
                ? "sidebar-dash-active nav-slide-dash"
                : "sidebar-dash-idle nav-slide-dash"
            }
          >
            {/* <div class={this.props.sidebarExpanded ? "sidebar nav-slide  mt-100" : "sidebar nav-slide  mt-100 sidebar-active"}> */}

            <div class={"display-flex jcsp head-slide-dash float-left sidebarTitle"}>
              {this.props.searchUserState &&
               <h5 className="css-14fcotf">Search User</h5>
              }
              {!this.props.prospect && !this.props.campaign && !this.props.keyPerformanceByAgentEntry && !this.props.keyPerformanceByCampaignEntry && !this.props.searchUserState? (

                <h6>Search Application</h6>
              ) : !this.props.campaign &&
                this.props.prospect &&
                !this.props.keyPerformanceByAgentEntry &&
                !this.props.keyPerformanceByCampaignEntry ? (
                <h5 className="css-14fcotf">Search Prospect</h5>
              ) : this.props.campaign &&
                !this.props.prospect &&
                !this.props.keyPerformanceByAgentEntry &&
                !this.props.keyPerformanceByCampaignEntry ? (
                <h5 className="css-14fcotf">Search Campaign</h5>
              ) : !this.props.campaign &&
                !this.props.prospect &&
                this.props.keyPerformanceByAgentEntry &&
                !this.props.keyPerformanceByCampaignEntry ? (
                <h6>Search Performance By Agent</h6>
              ) : !this.props.campaign &&
                !this.props.prospect &&
                !this.props.keyPerformanceByAgentEntry &&
                this.props.keyPerformanceByCampaignEntry ? (
                <h6>Search Performance By Campaign</h6>
              ) : null}
              {/* <CustomCloseIcon onClick={setSideBar(false)} /> */}
              {!this.props.showRightIcon && (
                <a
                  // type="button"
                  // id="sidebarCollapse"

                  class="btn btn-sidebaricon rounded-circle display-flex pull-right"
                  onClick={this.props.toggle}
                >
                  <ChevronLeftSharpIcon
                    className="toggle-icon-color"
                    onClick={this.props.toggle}
                  />
                  {/* <span class=" btn-toggle-text ml-2">Toggle Sidebar</span> */}
                </a>
              )}
            </div>

            <div class="text-left">

              {this.props.searchUserState &&
            <Input
                  forName={"userId"}
                  classLabel="control-label dashLabel color-white"
                  label="User ID"
                  type={"text"}
                  name="userId"
                  classInput={"form-control dashInput"}
                  value={searchUser.userId}
                  handleChange={(event)=>this.handleSearchFieldChange(event,"userId")}
                  handleOnBlur={() => { }}
                />
              }
              {!this.props.searchUserState && !this.props.prospect && !this.props.campaign && !this.props.keyPerformanceByAgentEntry && !this.props.keyPerformanceByCampaignEntry ? (

                <Input
                  forName={"appId"}
                  classLabel="control-label dashLabel color-white"
                  label="Application ID"
                  type={"text"}
                  name="appId"
                  classInput={"form-control dashInput"}
                  value={searchPayload.appId}
                  handleChange={(event) =>
                    this.handleSearchFieldChange(event, "appId")
                  }
                  handleOnBlur={() => {}}
                  autoComplete="off"
                  spellcheck="false"
                  aria-autocomplete="both"
                  aria-haspopup="false"
                />

              ) : this.props.prospect && !this.props.campaign && !this.props.searchUserState && !this.props.keyPerformanceByAgentEntry && !this.props.keyPerformanceByCampaignEntry ? (

                <div class="margin-left-0p5 text-left">
                  {/* <Input
                  forName={"fname"}
                  classLabel="control-label dashLabel color-white"
                  label="First Name"
                  type={"text"}
                  name="fname"
                  classInput={"form-control dashInput"}
                  value={prospectSearchPayload.fname}
                  handleChange={this.handleSearchFieldChange("fname")}
                  handleOnBlur={() => {}}
                /> */}
                  <div>
                    <label
                      for="leadId"
                      class="dashLabel color-white sidebar-field-margin"
                    >
                      Lead ID number
                    </label>
                    <TextField
                      name="leadId"
                      value={prospectSearchPayload.leadId}
                      size="small"
                      onChange={(event) =>
                        this.handleSearchFieldChange(event, "leadId")
                      }
                      variant="outlined"
                      inputProps={{
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                        style: { width: "10rem" },
                      }}
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="mt-2">
                    <label
                      for="fname"
                      class="dashLabel color-white sidebar-field-margin"
                    >
                      First Name
                    </label>
                    <TextField
                      name="fname"
                      value={prospectSearchPayload.fname}
                      size="small"
                      className="sidebar-field-width"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.handleSearchFieldChange(event, "fname");
                      }}
                      variant="outlined"
                      inputProps={{
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                      }}
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  {/* <Input
                  forName={"lname"}
                  classLabel="control-label dashLabel color-white"
                  label="Last Name"
                  type={"text"}
                  name="lname"
                  classInput={"form-control dashInput"}
                  value={prospectSearchPayload.lname}
                  handleChange={this.handleSearchFieldChange("lname")}
                  handleOnBlur={() => {}}
                /> */}
                  <div class="mt-2">
                    <label
                      for="lname"
                      class="dashLabel color-white sidebar-field-margin"
                    >
                      Last Name
                    </label>
                    <TextField
                      name="lname"
                      value={prospectSearchPayload.lname}
                      size="small"
                      className="sidebar-field-width"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.handleSearchFieldChange(event, "lname");
                      }}
                      variant="outlined"
                      inputProps={{
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                      }}
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                    {/* <Input
                  forName={"assigned"}
                  classLabel="control-label dashLabel color-white"
                  label="Assigned"
                  placeholder="Type agent name"
                  type={"text"}
                  name="assigned"
                  classInput={"form-control dashInput"}
                  value={prospectSearchPayload.assigned}
                  handleChange={this.handleSearchFieldChange("assigned")}
                  handleOnBlur={() => {}}
                /> */}
                  </div>
                  <div class="mt-2">
                    <label
                      for="campaignName"
                      class="dashLabel color-white sidebar-field-margin"
                    >
                      Plan Campaign Name
                    </label>
                    <TextField
                      name="campaignName"
                      value={prospectSearchPayload.campaignName}
                      size="small"
                      className="sidebar-field-width"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.handleSearchFieldChange(event, "campaignName");
                      }}
                      variant="outlined"
                      inputProps={{
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                      }}
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="mt-2">
                    {/* <TextField name="assigned"
                      value={prospectSearchPayload.assigned}
                      size="small"
                      className="sidebar-field-width"
                      onChange={this.handleSearchFieldChange("assigned")} label="Assigned To" variant="outlined" /> */}
                    {/* <span class="label-container"> */}
                    <label for="assignedTo" class="labelprospect">
                      Assigned To
                      {/* <span class="mandatory-field">*</span> */}
                    </label>
                    <br />
                    <AutoComplete1
                      // dashboard="prospect"
                      field="assignedTo"
                      disabled={
                        (!this?.props?.isSuperUser &&
                          this?.props?.customerId === "HCF0450") ||
                        this?.props?.isAgentRole
                      }
                      // error={
                      //   // props.prospectSaveFlag?
                      //   prospectSearchPayload.assigned === ""
                      // }
                      handleChange={this.handleOtherDropdown("assigned")}
                      options={
                        this.props.prospectagentList
                        //   ?.map((data) => ({
                        //   label: data?.value,
                        //   value: data?.label,
                        // }))
                      }
                      value={
                        this.props.prospectagentList?.filter(
                          (x) => x.value === prospectSearchPayload.assigned
                        ).length > 0
                          ? this.props.prospectagentList?.filter(
                              (x) => x.value === prospectSearchPayload.assigned
                            )[0]
                          : { label: "Select", value: "" }
                      }
                      // defaultValue={{label:"",value:""}}
                      name="assigned"
                      width="95%"
                    />
                    {/* </span> */}
                  </div>
                </div>
              ) : !this.props.prospect &&
                this.props.campaign &&
                !this.props.keyPerformanceByAgentEntry &&
                !this.props.keyPerformanceByCampaignEntry ? (
                <div class="text-left ml-2">
                  <div>
                    {/* <label
                    for="campaignId"
                    class="control-label dashLabel color-white"
                  >
                    e-Enroll Campaign ID
                  </label>
                  <input
                    type="text"
                    name="enrlCampaignId"
                    class="form-control dashInput"
                    onChange={this.changeHandler}
                    value={this.state.enrlCampaignId}
                  /> */}
                    <label
                      for="enrlCampaignId"
                      class="dashLabel color-white sidebar-field-margin"
                    >
                      e-Enroll Campaign ID
                    </label>
                    <TextField
                      name="enrlCampaignId"
                      value={this.state.enrlCampaignId}
                      size="small"
                      className="sidebar-field-width"
                      onChange={this.changeHandler}
                      variant="outlined"
                      inputProps={{
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                      }}
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="mt-2">
                    {/* <label
                    for="campaignName"
                    class="control-label dashLabel color-white"
                  >
                    Campaign Name
                  </label>
                  <input
                    type="text"
                    name="planCampaignName"
                    class="form-control dashInput"
                    onChange={this.changeHandler}
                    value={this.state.planCampaignName}
                  /> */}
                    <label
                      for="planCampaignName"
                      class="dashLabel color-white sidebar-field-margin"
                    >
                      Plan Campaign Name
                    </label>
                    <TextField
                      name="planCampaignName"
                      value={this.state.planCampaignName}
                      size="small"
                      className="sidebar-field-width"
                      onChange={(event) => {
                        if (
                          event.target.value !== "" &&
                          !DataValidation.test(event.target.value)
                        ) {
                          return;
                        }
                        this.changeHandler(event);
                      }}
                      variant="outlined"
                      inputProps={{
                        autoComplete: "off",
                        spellcheck: "false",
                        "aria-autocomplete": "both",
                        "aria-haspopup": "false",
                      }}
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>

                  <div class="mt-2">
                    <label
                      for="campaignOwner"
                      class="dashLabel color-white sidebar-field-margin"
                    >
                      Campaign Owner
                    </label>
                    {this.props.customerId === VERDA_CONSTS.ID ? (
                      <TextField
                        name="campaignOwner"
                        value={this.state.campaignOwner}
                        size="small"
                        className="sidebar-field-width"
                        onChange={this.changeHandler}
                        variant="outlined"
                        inputProps={{
                          autoComplete: "off",
                          spellcheck: "false",
                          "aria-autocomplete": "both",
                          "aria-haspopup": "false",
                        }}
                        spellcheck="false"
                        aria-autocomplete="both"
                        aria-haspopup="false"
                      />
                    ) : (
                      <Autocomplete2
                        error={false}
                        handleChange={this.handleDropdown("campaignOwner")}
                        options={
                          this?.props?.customerId === VERDA_CONSTS.ID
                            ? this.props.adminList
                            : this.props.campaignOwnerNamesList
                        }
                        value={
                          this?.props?.customerId === VERDA_CONSTS.ID
                            ? this.props.adminList?.length > 1 &&
                              this.props.adminList.filter(
                                (data1) =>
                                  data1.label === this.state.campaignOwner
                              )[0] !== undefined
                              ? this.props.adminList.filter(
                                  (data1) =>
                                    data1.label === this.state.campaignOwner
                                )[0]
                              : { label: "", value: "" }
                            : this.props.campaignOwnerNamesList?.length > 1 &&
                              this.props.campaignOwnerNamesList.filter(
                                (data1) =>
                                  data1.label === this.state.campaignOwner
                              )[0] !== undefined
                            ? this.props.campaignOwnerNamesList.filter(
                                (data1) =>
                                  data1.label === this.state.campaignOwner
                              )[0]
                            : {
                                label: this.state.campaignOwner,
                                value: "",
                              }
                        }
                        // disabled={
                        //   this.state.enrlCampaignId == ""
                        //     ? false
                        //     : !this.state.editFormCssInd
                        // }
                        width="95%"
                        show={true}
                      />
                    )}
                  </div>
                </div>
              ) : !this.props.prospect &&
                !this.props.campaign &&
                (this.props.keyPerformanceByAgentEntry ||
                  this.props.keyPerformanceByCampaignEntry) ? (
                <div>
                  <div>
                    <label
                      for="startDate"
                      class="control-label dashLabel color-white"
                    >
                      Start Date
                    </label>
                    <input
                      class={"form-control1"}
                      value={this.state.startDate}
                      maxLength="10"
                      onChange={this.handleDate}
                      onClick={(e) => this.handleDates("startDate")}
                      name="startDate"
                      id="startDate"
                      placeholder="MM/DD/YYYY"
                      required=""
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div>
                    <label
                      for="endDate"
                      class="control-label dashLabel color-white"
                    >
                      End Date
                    </label>
                    <input
                      class={"form-control1"}
                      value={this.state.endDate}
                      maxLength="10"
                      onChange={this.handleDate}
                      onClick={(e) => this.handleDates("endDate")}
                      name="endDate"
                      id="endDate"
                      placeholder="MM/DD/YYYY"
                      required=""
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
              ) : null}
              {(this.props.prospect || this.props.campaign) &&
              !this.props.keyPerformanceByAgentEntry &&
              !this.props.keyPerformanceByCampaignEntry ? (
                <div class="margin-left-0p5 text-left">
                  <label
                    for="prospectStatus"
                    class="dashLabel color-white sidebar-field-margin"
                  >
                    Status
                  </label>
                  {this.props.campaign ? (
                    <AutoComplete
                      field="Status"
                      dashboard="campaign"
                      height="7px !important"
                      width="187px"
                      handleChange={(event) =>
                        this.handleSearchFieldChange(event, "campaignStatus")
                      }
                      options={prospectStatusOptions}
                      defaultValue={
                        prospectStatusOptions.filter(
                          (data) =>
                            data.value === prospectSearchPayload.campaignStatus
                        )[0]
                      }
                      value={
                        prospectStatusOptions.filter(
                          (data) =>
                            data.value === prospectSearchPayload.campaignStatus
                        )[0]
                      }
                      name="prospectStatus"
                    />
                  ) : (
                    <AutoComplete
                      dashboard="campaign"
                      height="7px !important"
                      field="Status"
                      width="187px"
                      handleChange={(event) =>
                        this.handleSearchFieldChange(event, "prospectStatus")
                      }
                      options={prospectStatusOptions}
                      defaultValue={
                        prospectStatusOptions.filter(
                          (data) =>
                            data.value === prospectSearchPayload.prospectStatus
                        )[0]
                      }
                      value={
                        prospectStatusOptions.filter(
                          (data) =>
                            data.value === prospectSearchPayload.prospectStatus
                        )[0]
                      }
                      name="prospectStatus"
                    />
                  )}
                </div>

              ) : !this.props.campaign && !this.props.searchUserState && !this.props.keyPerformanceByAgentEntry && !this.props.keyPerformanceByCampaignEntry ? (

                <div class="margin-left-0p5 text-left">
                  <label
                    for="category"
                    class="control-label dashLabel color-white sidebar-field-margin"
                  >
                    Application Category
                  </label>
                  <AutoComplete1
                    handleChange={(event) =>
                      this.handleSearchFieldChange(event, "category")
                    }
                    width="97%"
                    backgroundColor="white"
                    options={catergoryOptions}
                    defaultValue={
                      catergoryOptions.filter(
                        (data) => data.value === searchPayload.category
                      )[0]
                    }
                    value={
                      catergoryOptions.filter(
                        (data) => data.value === searchPayload.category
                      )[0]
                    }
                    name="category"
                    marginTop="0px"
                  />
                </div>
              ) : (
                ""
              )}
              {displayStatusDropdown && (
                <label
                  for="category"
                  class="control-label dashLabel color-white sidebar-field-margin"
                >
                  Application Status
                </label>
              )}
              {displayStatusDropdown && (
                <AutoComplete1
                  handleChange={(event) =>
                    this.handleSearchFieldChange(event, "status")
                  }
                  width="97%"
                  //label="Application Status"
                  options={statusOptions}
                  defaultValue={
                    statusOptions.filter(
                      (data) => data.value === searchPayload.status
                    )[0]
                  }
                  value={
                    statusOptions.filter(
                      (data) => data.value === searchPayload.status
                    )[0]
                  }
                  name="status"
                  marginTop="0px"
                />
              )}
            </div>
            <div class="siderbar-btn">
              <Button
                buttonLabel={"Reset"}
                onButtonClick={this.reset}
                className="btn btn-dashboard mt-4 ml-3"
              />
              <Button
                // className={"btn-primary-continue-dash mt-10"}
                className="btn btn-dashboard-active mt-4 ml-2 btn-dashboard-active-color"
                onButtonClick={this.handleSearch}
                buttonLabel={"Search"}
                id="SearchBtn"
                // disableButton={!allReqFieldsAvailable}
              />
              {/* {this.props.searchappl || this.props.prospect || this.props.campaign || this.props.keyPerformanceByAgentEntry || this.props.keyPerformanceByCampaignEntry? ( */}

              {/* ) : null} */}
            </div>
            <br />

          
          </div>
          </>
         : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.login.customerId,
    cardDetails: state.webApp.planCardData,
    emailId: state.login.emailAddress,
    agentEmailId: state.login.agentEmailId,
    prospect: state.campaignProspect.prospectStateEntry,
    campaign: state.campaignProspect.campaignStateEntry,
    keyPerformanceByAgentEntry: state.webApp.keyPerformanceByAgentEntry,
    keyPerformanceByCampaignEntry: state.webApp.keyPerformanceByCampaignEntry,
    // prospectagentList:state.campaignProspect.agentList,
    prospectagentList: state.webApp.membershipAgentList,
    isSuperUser: state.webApp.isSuperUser,
    agentFullName: state.login.agentFullName,

    campaignOwnerNamesList:state.campaignProspect.campaignOwnerNamesList,
    UserManagementData:state.user.UserManagementData

  };
};
const mapDispatchToProps = {
  searchExistingApplication,
  searchProspect,
  searchCampaign,
  setStateParams,
  keyPerformanceByAgent,
  keyPerformanceByCampaign,
  getAgentPerformanceExport,
  getCampaignPerformanceExport,
  setUserManagementState
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBarDashboard);
